import { ModalConfirmationContext } from "components/Modal";
import { useContext } from "react";

const useModalConfirmation = () => useContext(ModalConfirmationContext);

export default useModalConfirmation;
